import type { CalendarSource } from './types';

export interface PlannerSourceIdentityLabel {
  sourceFullLabel: string;
  sourceShortLabel: string;
}

export class CalendarSourcePresentationError extends Error {
  readonly code = 'owner_profile_unavailable';

  constructor(message: string) {
    super(message);
    this.name = 'CalendarSourcePresentationError';
  }
}

/** Pure presentation policy. Authorization and owner lookup remain server-owned. */
export function plannerSourceIdentityLabel(
  source: Pick<CalendarSource, 'owner' | 'scope' | 'title'>
): PlannerSourceIdentityLabel {
  const title = source.title.trim();
  if (!title)
    throw new CalendarSourcePresentationError('Calendar title is blank');
  if (source.scope === 'shared') {
    return { sourceFullLabel: title, sourceShortLabel: title };
  }
  const owner = source.owner?.displayName.trim();
  if (!owner) {
    throw new CalendarSourcePresentationError(
      'Private calendar owner presentation is unavailable'
    );
  }
  return {
    sourceFullLabel: `${owner} · ${title}`,
    sourceShortLabel: owner,
  };
}
